import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Panel} from 'react-bootstrap';
import Button from '@material-ui/core/Button';
import {CommonModal} from 'components/common';
import {SecondaryNavigation} from 'components/Navigation';
import UserTable from './UserTable';
import UserCreation from './UserCreation';
import {
  fetchUsers,
  setCurrentUserPage,
  clearUsersAfterPage,
  fetchParents,
  setCurrentParentPage,
  clearParentsAfterPage,
} from 'actions/users';
import {isTeacher} from 'utils/permissions';

class UserList extends React.Component {
  static propTypes = {
    userPages: PropTypes.object.isRequired,
    parentPages: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      modalShown: false,
      userTableKey: 0,
    };
    this.showModal = this.showModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.handleCreationSuccess = this.handleCreationSuccess.bind(this);
  }

  showModal() {
    this.setState({
      modalShown: true,
    });
  }

  closeModal() {
    this.setState({
      modalShown: false,
    });
  }

  handleCreationSuccess() {
    this.setState((prevState) => ({
      modalShown: false,
      userTableKey: prevState.userTableKey + 1,
    }));
  }

  render() {
    const {modalShown, userTableKey} = this.state;
    const {
      myRole,
      userReaderOnly,
      userId,
      activeSchool,
      userPages,
      fetchUsers,
      setCurrentUserPage,
      clearUsersAfterPage,
      parentPages,
      fetchParents,
      setCurrentParentPage,
      clearParentsAfterPage,
      hiddenFields,
    } = this.props;
    return (
      <div>
        {!userReaderOnly && (
          <React.Fragment>
            <CommonModal
              title={`Create New ${isTeacher(myRole) ? 'Teacher' : 'User'}`}
              onClose={this.closeModal}
              show={modalShown}
            >
              <UserCreation
                schoolId={activeSchool ? activeSchool.id : undefined}
                onSubmitSuccess={this.handleCreationSuccess}
              />
            </CommonModal>
            <SecondaryNavigation
              tabs={
                isTeacher(myRole)
                  ? [{url: '/users', label: 'Users', isActive: true}]
                  : [
                      {url: '/users', label: 'Users', isActive: true},
                      {url: '/users/invitations', label: 'Invitations', isActive: false},
                      // {url: '/users/parent-student-association', label: 'Link Parent and Student', isActive: false},
                    ]
              }
            />
          </React.Fragment>
        )}
        <div className="container content-box">
          <Panel>
            {!userReaderOnly ? (
              <h3 className="section-header">
                <div className="section-title">Users</div>
                {!isTeacher(myRole) && (
                  <Button variant="contained" color="primary" className="pull-right" onClick={this.showModal}>
                    Create User (Without Sending Invitation Email)
                  </Button>
                )}
              </h3>
            ) : (
              <h3 className="section-header">
                <div className="section-title">User's Student</div>
              </h3>
            )}
            <UserTable
              {...{
                userTableKey,
                recordPages: userPages,
                fetchRecords: (q, page, perPage, sortOpts, extraFilters = {}) =>
                  fetchUsers(q, page, perPage, sortOpts, {...extraFilters, userId, userReaderOnly}),
                setCurrentRecordPage: setCurrentUserPage,
                clearRecordsAfterPage: clearUsersAfterPage,
                hiddenFields,
                extraFiltersEnabled: !userReaderOnly,
                extraFilterProps: {myRole},
              }}
            />
          </Panel>
          {/*{isSchoolCoordinatorOrTeacher(myRole) && (*/}
          {/*  <Panel>*/}
          {/*    <h3 className="section-header">*/}
          {/*      <div className="section-title">Parents</div>*/}
          {/*    </h3>*/}
          {/*    <UserTable*/}
          {/*      {...{*/}
          {/*        recordPages: parentPages,*/}
          {/*        fetchRecords: (q, page, perPage, sortOpts, extraFilters = {}) =>*/}
          {/*          fetchParents(q, page, perPage, sortOpts, {...extraFilters, userId}),*/}
          {/*        setCurrentRecordPage: setCurrentParentPage,*/}
          {/*        clearRecordsAfterPage: clearParentsAfterPage,*/}
          {/*        hiddenFields,*/}
          {/*      }}*/}
          {/*    />*/}
          {/*  </Panel>*/}
          {/*)}*/}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const {account, users} = state;
  const activeSchool = account.getIn(['user', 'activeSchool']);
  return {
    myRole: account.getIn(['user', 'role']),
    activeSchool: activeSchool ? activeSchool.toJS() : null,
    userPages: users.get('userPages').toJS(),
    parentPages: users.get('parentPages').toJS(),
  };
};

const mapDispatchToProps = {
  fetchUsers,
  setCurrentUserPage,
  clearUsersAfterPage,
  fetchParents,
  setCurrentParentPage,
  clearParentsAfterPage,
};

export default connect(mapStateToProps, mapDispatchToProps)(UserList);
